<template>
  <div class="card-block">
    <div class="row" v-if="isLoading && !team">
      <div class="col-md-12 card-stat">
        <loading-indicator></loading-indicator>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-md-6 col-xs-12" v-if="showBillingCredit">
        <h3 class="card-title">
          {{ $t("billing.action.addCredit") }}
        </h3>
        <div class="payment-method" v-if="team.available_payment_methods.length > 1">
          <div class="form-radio">
            <div class="row">
              <div class="col-md-4" v-for="item in team.available_payment_methods">
                <div class="form-check" v-bind:class="{ active: currentPaymentMethod === item }" v-on:click="currentPaymentMethod = item">
                  <label class="form-check-label custom-control custom-radio">
                    <input id="radio1" name="radio" type="radio" class="form-check-input custom-control-input" :value="item" v-model="currentPaymentMethod">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description">
                      <img src="https://assets.omise.co/assets/omise-logo-a86debcb438f41aa395a868ff43fe67090e277d44dea080cd2d51baec405ea71.svg" height="24" alt="PayPal Logo" v-if="item === 'omise'">
                      <img src="https://www.paypalobjects.com/webstatic/mktg/Logo/pp-logo-150px.png" border="0" alt="PayPal Logo" height="24" v-if="item === 'paypal'">
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <BillingCreditOmise
          v-if="showOmisePayment && currentPaymentMethod === 'omise'"
          v-bind:team="team"
          v-on:loadChanged="billingCreditLoadChanged">
        </BillingCreditOmise>
        <BillingCreditPayPal
          v-if="showPayPalPayment && currentPaymentMethod === 'paypal'"
          v-bind:team="team"
          v-on:loadChanged="billingCreditLoadChanged">
        </BillingCreditPayPal>
        <BillingCreditDirect
          v-if="!showOmisePayment && !showPayPalPayment"
        >
        </BillingCreditDirect>
      </div>
      <div class="col-md-6 col-xs-12" v-if="showBillingInformation">
        <Billing-information
          v-bind:team="team"
          v-on:loadChanged="billingInformationLoadChanged">
        </Billing-information>
      </div>
    </div>
  </div>
</template>

<script>
import BillingCreditDirect from 'components/billings/payments/BillingCreditDirect';
import BillingCreditOmise from 'components/billings/payments/BillingCreditOmise';
import BillingCreditPayPal from 'components/billings/payments/BillingCreditPayPal';
import BillingInformation from 'components/billings/payments/BillingInformation';
import LoadingIndicator from 'components/LoadingIndicator';

export default {
  components: {
    BillingCreditDirect,
    BillingCreditOmise,
    BillingCreditPayPal,
    BillingInformation,
    LoadingIndicator,
  },
  props: {
    team: {
      type: Object,
    },
    showBillingCredit: {
      type: Boolean,
    },
    showBillingInformation: {
      type: Boolean,
    },
  },
  data() {
    return {
      currentPaymentMethod: null,
    };
  },
  computed: {
    isLoading: function() {
      const loading = (
        this.isBillingCreditLoading ||
        this.isBillingInformationLoading);

      this.$emit('loadChanged', loading);

      return loading;
    },
    showOmisePayment () {
      const paymentMethod = 'omise';
      return this.isPaymentAvailable(paymentMethod);
    },
    showPayPalPayment () {
      const paymentMethod = 'paypal';
      return this.isPaymentAvailable(paymentMethod);
    },
  },
  created: function() {
    if (this.team.available_payment_methods) {
      this.currentPaymentMethod = this.team.available_payment_methods[0];
    }
  },
  mounted: function() {

  },
  methods: {
    isPaymentAvailable (paymentMethod) {
      if (this.team.available_payment_methods) {
        let isAvailable = false;
        isAvailable = this.team.available_payment_methods.find((item) => {
          if (item === paymentMethod) {
            return true;
          }
        });
        return isAvailable;
      }
      return false;
    },
    billingCreditLoadChanged: function(value) {
      this.isBillingCreditLoading = value;
    },
    billingInformationLoadChanged: function(value) {
      this.isBillingInformationLoading = value;
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PaymentSection.vue?f2843784